export default function getConfig() {
  var conf;
  var env = "prod";
  switch (env) {
    case "prod":
      conf = {
        cloudFunctions: {
          sendReceipt:
            "https://us-central1-generate-pdfs.cloudfunctions.net/sendReceipt"
        },
        firebaseApiKey: {
          apiKey: "AIzaSyDyyLM3m_QB7ce6bfc0Ib1Jh3MFGgnO5b8",
          authDomain: "ndlm-portal.firebaseapp.com",
          databaseURL: "https://ndlm-portal.firebaseio.com",
          projectId: "ndlm-portal",
          storageBucket: "ndlm-portal.appspot.com",
          messagingSenderId: "610538703041",
          appId: "1:610538703041:web:5c34cd497b36128f"
        }
      };
      break;
    case "test":
      conf = {
        cloudFunctions: {
          sendReceipt:
            "https://us-central1-ndlmfrontend.cloudfunctions.net/sendReceipt"
        },
        firebaseApiKey: {
          apiKey: "AIzaSyC08C8utENWo0flCIBlm4BY2ToMTXkIvO0",
          authDomain: "ndlmfrontend.firebaseapp.com",
          databaseURL: "https://ndlmfrontend.firebaseio.com",
          projectId: "ndlmfrontend",
          storageBucket: "ndlmfrontend.appspot.com",
          messagingSenderId: "377554670469"
        }
      };
      break;
    case "default":
      conf = {
        cloudFunctions: {
          sendReceipt:
            "http://localhost:5000/ndlmfrontend/us-central1/sendReceipt"
        },
        firebaseApiKey: {
          apiKey: "AIzaSyC08C8utENWo0flCIBlm4BY2ToMTXkIvO0",
          authDomain: "ndlmfrontend.firebaseapp.com",
          databaseURL: "https://ndlmfrontend.firebaseio.com",
          projectId: "ndlmfrontend",
          storageBucket: "ndlmfrontend.appspot.com",
          messagingSenderId: "377554670469"
        }
      };
      break;
  }

  return conf;
}
